// @tennis-matches/services/auth
// Mapping von Supabase Auth / Netzwerkfehlern zu stabilen i18n-Keys (ohne Rohmeldungen in der UI).

/**
 * Nur in Development: technische Details für Debugging (keine Nutzer-Strings).
 * @param {string} scope
 * @param {unknown} err
 * @param {Record<string, unknown>} [extra]
 */
export function logAuthErrorDev(scope, err, extra = {}) {
  try {
    const dev =
      (typeof import.meta !== "undefined" &&
        import.meta.env &&
        import.meta.env.DEV) ||
      (typeof process !== "undefined" &&
        process.env &&
        process.env.NODE_ENV === "development");
    if (!dev) return;
    const e = err && typeof err === "object" ? err : null;
    console.warn(`[auth] ${scope}`, {
      message: String(e?.message ?? err ?? ""),
      status: e?.status ?? e?.statusCode ?? null,
      code: e?.code ?? null,
      name: e?.name ?? null,
      ...extra,
    });
  } catch {
    /* ignore */
  }
}

/**
 * @param {unknown} err
 * @returns {string} i18n-Key unter auth.signupError.*
 */
export function getSignupErrorI18nKey(err) {
  const e = err && typeof err === "object" ? err : null;
  const raw = String(e?.message ?? err ?? "");
  const msg = raw.toLowerCase();
  const status = Number(e?.status ?? e?.statusCode ?? 0);
  const code = String(e?.code ?? "").toLowerCase();

  if (
    status === 500 ||
    status === 504 ||
    msg.includes("504") ||
    msg.includes("gateway timeout")
  ) {
    return "auth.signupError.confirmationEmailServer";
  }
  if (
    msg.includes("500") &&
    (msg.includes("internal") || msg.includes("server error"))
  ) {
    return "auth.signupError.confirmationEmailServer";
  }

  if (
    msg.includes("error sending confirmation email") ||
    (msg.includes("confirmation") &&
      msg.includes("email") &&
      (msg.includes("error") || msg.includes("send")))
  ) {
    return "auth.signupError.confirmationEmailFailed";
  }

  if (
    status === 429 ||
    code === "over_email_send_rate_limit" ||
    msg.includes("email rate limit") ||
    msg.includes("over_email_send_rate_limit")
  ) {
    return "auth.signupError.confirmationEmailRateLimited";
  }

  if (
    msg.includes("already registered") ||
    msg.includes("already been registered") ||
    msg.includes("user already") ||
    msg.includes("email address is already") ||
    msg.includes("already exists") ||
    code === "email_exists" ||
    code === "user_already_exists"
  ) {
    return "auth.signupError.userAlreadyRegistered";
  }

  if (
    (msg.includes("password") || msg.includes("passwort")) &&
    (msg.includes("weak") ||
      msg.includes("at least") ||
      msg.includes("least 6") ||
      msg.includes("least 8") ||
      msg.includes("too short") ||
      msg.includes("zu kurz"))
  ) {
    return "auth.signupError.weakPassword";
  }

  if (msg.includes("invalid email")) {
    return "auth.signupError.invalidEmail";
  }

  if (
    msg.includes("failed to fetch") ||
    msg.includes("network error") ||
    msg.includes("load failed") ||
    msg.includes("networkerror")
  ) {
    return "auth.signupError.network";
  }

  return "auth.signupError.generic";
}
